<div *ngIf="!data.withoutIcon" class="icon mr-3" [inlineSVG]="'/icons/icon-check-circle.svg'"></div>
<span class="msg" *ngIf="data.translate">
  {{ data.msg | translate }}
</span>
<span class="msg" *ngIf="!data.translate">
  {{ data.msg }}
</span>
<span class="d-block close-icon pl-2" [inlineSVG]="'/icons/no-stroke-icon-close.svg'" (click)="close()"></span>
